/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { TextBlock } from './TextBlock'
import {
  TextBlockFromJSON,
  TextBlockFromJSONTyped,
  TextBlockToJSON,
} from './TextBlock'

/**
 * Элемент частых вопросов — единая структура для общего списка (GET /faq) и привязанных к инструкции вопросов (faq[] в GET /instructions/{slug}); DTO — App\Service\Post\Content\Resolvers\Data\FaqItemData
 * @export
 * @interface FaqItem
 */
export interface FaqItem {
  /**
   * Заголовок записи частого вопроса
   * @type {string}
   * @memberof FaqItem
   */
  title: string
  /**
   * Порядок сортировки (meta.extra.sort_order), PHP_INT_MAX (9223372036854775807) — не задан
   * @type {number}
   * @memberof FaqItem
   */
  order?: number
  /**
   * Конструктор ответа частого вопроса — аналог Content, но блоки только типа text_block (data.content — HTML); пустой конструктор — [], не null
   * @type {Array<TextBlock>}
   * @memberof FaqItem
   */
  constructor: Array<TextBlock>
}

/**
 * Check if a given object implements the FaqItem interface.
 */
export function instanceOfFaqItem(value: object): value is FaqItem {
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('constructor' in value) || value['constructor'] === undefined)
    return false
  return true
}

export function FaqItemFromJSON(json: any): FaqItem {
  return FaqItemFromJSONTyped(json, false)
}

export function FaqItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FaqItem {
  if (json == null) {
    return json
  }
  return {
    title: json['title'],
    order: json['order'] == null ? undefined : json['order'],
    constructor: (json['constructor'] as Array<any>).map(TextBlockFromJSON),
  }
}

export function FaqItemToJSON(value?: FaqItem | null): any {
  if (value == null) {
    return value
  }
  return {
    title: value['title'],
    order: value['order'],
    constructor: (value['constructor'] as Array<any>).map(TextBlockToJSON),
  }
}
